// src/components/SyncTab.js
import React from "react";
import { AlertTriangle } from "lucide-react";

export default function SyncTab({
  rawCsvPaste,
  setRawCsvPaste,
  handleCsvImport,
  handleResetData,
}) {
  return (
    <div className="space-y-6 max-w-3xl mx-auto animate-fadeIn">
      <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 space-y-4">
        <h2 className="text-base font-black text-slate-900">
          Importação Inicial Google Sheets / CSV
        </h2>
        <textarea
          value={rawCsvPaste}
          onChange={(e) => setRawCsvPaste(e.target.value)}
          rows={4}
          placeholder="Apartamento;Quarto;Inquilino;Renda;Caucao;CheckIn;CheckOut"
          className="w-full bg-slate-50 border rounded-xl p-3 text-xs font-mono"
        />
        <button
          onClick={handleCsvImport}
          className="bg-emerald-600 text-white font-bold px-4 py-2 rounded-xl text-xs"
        >
          Sincronizar CSV
        </button>
      </div>
      <div className="bg-rose-50 border border-rose-200 p-6 rounded-2xl space-y-3">
        <h3 className="font-extrabold text-xs text-rose-800 uppercase tracking-wider flex items-center gap-1.5">
          <AlertTriangle size={16} /> Zona de Reset / Perigo Local
        </h3>
        <button
          onClick={handleResetData}
          className="bg-rose-600 hover:bg-rose-700 text-white text-xs font-black px-5 py-2.5 rounded-xl flex items-center gap-2 transition-all shadow"
        >
          Limpar Memória Local
        </button>
      </div>
    </div>
  );
}
